import styled from 'styled-components';

export const ContainerChecklists = styled.section`
	font-family: Poppins, Heltica, Arial, sans-serif;
	color: #707070;
	margin-top: 35px;

	.checklist {
		flex-wrap: wrap;
	}

	.tot-selecteds {
		display: inline-block;
		margin-left: 5px;
	}

	.container-checklist {
		min-width: 300px;
		margin: 20px 40px 0 0;

		&:last-child {
			margin-right: 0;
		}
	}

	.title-checklist {
		font-family: Poppins-Medium, Heltica, Arial, sans-serif;
		font-size: 15px;
		margin-bottom: 0;
	}	

	.title-container {
		font-size: 15px;
	}

	.form-check {
		font-size: 14px;
		padding: 0;
		margin-bottom: 10px;

		input {
			margin-top: 5px;
		}

		[type="checkbox"]:not(:checked),
		[type="checkbox"]:checked {
			position: absolute;
			left: -9999px;
		}

		[type="checkbox"]:not(:checked) + label,
		[type="checkbox"]:checked + label {
			position: relative;
			padding-left: 1.95em;
			cursor: pointer;
		}

		[type="checkbox"]:not(:checked) + label:before {
			content: '';
			position: absolute;
			left: 0; 
			top: 0;
			width: 1.25em; height: 1.25em;
			border: 1px solid #707070;
			background: #FFFFFF;
		}

		[type="checkbox"]:checked + label:before {
			content: '';
			position: absolute;
			left: 0; 
			top: 0;
			width: 1.25em; height: 1.25em;
			border: 1px solid #707070;
			background: #707070;
		}
	}
`;

export const ButtonGear = styled.button`
	font-family: Poppins, Heltica, Arial, sans-serif;
	border-radius: 8px;
	background-color: #0FC821;
	color: #FFFFFF;
	font-size: 15px;
	text-transform: uppercase;
	padding: 10px 30px;
	border: 1px solid #0FC821;	
	transition: all .3s ease-in-out;
	outline: 0;

	&:hover {
		background-color: transparent;
		color: #0FC821;
		border: 1px solid #0FC821;	
	}

	&:focus {
		outline: 0;
	}
`;

export const Box = styled.div`
	box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
	margin-top: ${props => props.marginTop || null};
	border-radius: ${props => props.borderRadius || null};
	padding: ${props => props.padding || null};
`;

export const BriefingsDetails = styled.div`
	.component-briefing {
		header {
			display: flex;
			align-items: center;

			.fa.fa-bullhorn {
				color: #f3463c;
				margin-right: 10px;
				font-size: 15px;
			}

			.title {
				font-family: Poppins-Medium,
					Heltica,
					Arial,
					sans-serif;
				font-size: 14px;
			}
		}

		.container-button {
			display: flex;
			align-items: center;
			justify-content: flex-end;
		}
	}

	.content-briefings-details {
		svg.status-briefing {
			max-width: 1250px;
			width: 80%;
			display: block;
			margin: 50px
				auto;
			enable-background: new
				0
				0
				973.31
				73.52;

			.st0 {
				fill: #707070;
			}
			.st1 {
				fill: #5e5e5e;
			}
			.st2 {
				font-family: 'Arial';
				font-weight: bold;
			}
			.st3 {
				font-size: 12px;
			}
			.st4 {
				fill: #ffffff;
			}
			.st5 {
				font-family: 'Arial';
				font-weight: bold;
			}
			.st6 {
				font-size: 22.8099px;
			}
			.st7 {
				font-size: 21.1523px;
			}
			.st8 {
				fill: #666666;
			}
			.st9 {
				font-size: 21.8501px;
			}
			.st10 {
				fill: none;
			}
			.st11 {
				font-size: 22.7451px;
			}
			.st12 {
				font-size: 22.4161px;
			}
			.st13 {
				font-size: 22.2188px;
			}
			.st14 {
				font-size: 20.7147px;
			}
			.st15 {
				font-size: 21.6872px;
			}

			.cls-1 {
				fill: #707070;
			}
			.cls-2,
			.cls-8 {
				font-size: 12px;
			}
			.cls-2 {
				fill: #5e5e5e;
			}
			.cls-2,
			.cls-7,
			.cls-8 {
				font-family: Arial,
					Arial;
			}
			.cls-3 {
				letter-spacing: -0.06em;
			}
			.cls-4 {
				font-size: 37.24px;
				font-family: Arial,
					Arial;
			}
			.cls-4,
			.cls-7 {
				fill: #f9f9f9;
			}
			.cls-5 {
				letter-spacing: -0.04em;
			}
			.cls-6 {
				letter-spacing: -0.07em;
			}
			.cls-7 {
				font-size: 21.51px;
			}
			.cls-8 {
				fill: #666;
			}
			.cls-9 {
				letter-spacing: -0.02em;
			}

			#circle1,
			#circle2,
			#circle3,
			#circle4,
			#circle5,
			#circle6,
			#circle7,
			#circle8 {
				cursor: pointer;

				&:hover {
					circle {
						fill: #ffffff;
						stroke: #a4a1a3;
						stroke-width: 2px;
					}

					text.content-text {
						fill: #707070;
					}
				}
			}

			@media screen and (max-width: 1366px) {
				max-width: 1000px;
			}

			@media screen and (max-width: 480px) {
				display: none;
			}
		}

		.container-begin-briefing {
			.subtitle {
				display: inline-block;
				padding: 15px
					0;
				font-size: 1.5em;
				font-family: Poppins,
					Heltica,
					Arial,
					sans-serif;
			}

			.back-to-list {
				font-family: Poppins,
					Heltica,
					Arial,
					sans-serif;
				font-size: 14px;
				display: block;
				margin: 20px
					0;
			}

			.container-fluid {
				padding: 0
					27px;
			}

			img.status {
				max-width: 90px;
				display: none;
				margin: 40px
					auto
					30px;

				@media screen and (max-width: 480px) {
					display: block;
				}
			}
		}

		@media screen and (max-width: 760px) {
			padding-left: 57px;
		}

		h2.content-title {
			font-family: Poppins,
				Heltica,
				Arial,
				sans-serif;
			background-color: #ffffff;
			font-size: 2.5em;
			padding: 15px
				14px;
		}

		a.back-briefings {
			display: block;
			font-family: Poppins,
				Heltica,
				Arial,
				sans-serif;
			font-size: 1.4em;
			color: #ffffff;
			padding: 20px
				0;
			text-decoration: none;

			&:hover {
				opacity: 0.7;
			}
		}

		.box-content {
			padding: 20px !important;

			.content-briefing {
				margin: 0;
			}

			.content-briefing
				.component-title-step {
				margin: 0
					auto
					30px;
				background-color: #707070 !important;
				h3 {
					color: white !important;
					font-size: 1.6em;
				}
			}

			.general {
				max-width: 1250px;
				padding: 0
					30px;
				margin: 30px
					auto;

				hr {
					margin: 25px
						0;
				}

				.question
					p {
					font-family: Poppins,
						Heltica,
						Arial,
						sans-serif;
					line-height: 2.3em;
					font-size: 1.5em;
					color: #505059;
					text-align: left;
					word-break: break-all;
					word-wrap: break-word;

					&.text {
						background-color: #ecedf2 !important;
					}

					&.title {
						font-family: Poppins-Medium,
							Heltica,
							Arial,
							sans-serif;
					}
				}
			}

			.content-briefing {
				text-align: left;
				margin: 0
					auto;
			}
		}

		.group-buttons {
			max-width: 355px;
			margin: 60px
				auto
				0;
			display: -webkit-flex;
			display: flex;
			-webkit-justify-content: space-between;
			justify-content: space-between;

			.btn {
				width: 44%;
				padding: 5px
					0;
				font-weight: bold;
			}

			.btn.btn-light {
				background-color: #ffffff;
				border: 2px
					solid
					#b2b2b2;
				color: #b2b2b2;
			}

			.btn.btn-success {
				background-color: #41c351;
				border: 2px
					solid
					#41c351;
				color: #ffffff;
			}
		}
	}
`;
